import Vue from 'vue'
import App from './App.vue'
import router from './router'
// elementui
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css';
// 导入导航栏
import HelloWorld from '@/components/HelloWorld.vue'
// 导入底部
import Footer from '@/components/Footer.vue'
// 导入右侧图标
import Righticon from '@/components/RightIcon.vue'
// 导入中间图片
import Content from '@/components/Content.vue'

// 导入塑料橡胶导航栏
// import NavigationRub from '@/components/NavigationRub.vue'
// i18n
import VueI18n from 'vue-i18n'
// css样式
import './css/index.css';
// 引入axios
import axios from 'axios'

axios.defaults.baseURL='https://lab.sealtech.com/lab/api';

 //每个 Vue 对象都会新增一个 axios 对象
 Vue.prototype.$http = axios;
// 全局注册导航栏
Vue.component("MyHelloWorld",HelloWorld)

// 全局注册底部
Vue.component("MyFooter",Footer)
// 全局注册右边图标
Vue.component("Righticon",Righticon)
// 导入中间图片
Vue.component("Content",Content)

// 全局注册塑料橡胶导航栏
// Vue.component("NavigationRub",NavigationRub)



Vue.use(ElementUI);
Vue.use(VueI18n) 
Vue.config.productionTip = false

var v_locale = localStorage.getItem("v_locale");


const i18n = new VueI18n({ 
  locale:v_locale == null ? 'SC':v_locale, // 语言标识 
  messages: { 
   'SC': require('./assets/lang/zh'),
   'TC': require('./assets/lang/cn'),
   'EN': require('./assets/lang/en'),
   
  } 
 }) 
// 每次跳转到页面顶部
 router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
});


new Vue({
  data:function(){
    return{
      meta:"",
      meta1:""
    }
  },
  router,

  i18n,
  render: h => h(App)
}).$mount('#app')
  